import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "prismos.sidebar.collapsed";

function readInitial(): boolean {
  // SSR/test guard — localStorage faqat browserda mavjud
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Sidebar yig'ilgan/ochilgan holatini localStorage'da saqlaydi.
 * Qaytaradi: [collapsed, toggle, setCollapsed].
 */
export function useSidebarCollapsed(): [
  boolean,
  () => void,
  (value: boolean) => void,
] {
  const [collapsed, setCollapsed] = useState<boolean>(readInitial);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch {
      // private mode / quota — holat baribir sessiya ichida ishlaydi
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((v) => !v), []);

  return [collapsed, toggle, setCollapsed];
}
